// import { useSelector } from 'react-redux';
import configureStore from './configureStore';
import { setActiveScopeFromSession } from './activeScope';

/**
 * @type {{
 *   getState: () => object;
 *   dispatch: (arg0: {
 *       type: string;
 *       payload: object;
 *   }) => void;
 *   purge: () => void;
 * }}
 */
let _reduxOffline;

export function getStatus() {
    const {
        offline: { busy, online, outbox, retryCount, retryScheduled }
    } = _reduxOffline.getState();
    return { busy, online, pendingCount: outbox.length, retryCount, retryScheduled };
}

/**
 *
 * @param {import('../eventSink').EventSink } eventSink
 * @param {object} [session] the live session, used to attribute queued writes to their tenant and use case
 */
export async function initialize(eventSink, session) {
    // Seed before the store is built, so nothing can drain against an unknown scope.
    setActiveScopeFromSession(session);
    _reduxOffline = await configureStore(eventSink);
}

export function process(action) {
    return _reduxOffline.dispatch(action);
}

export function enable(enable) {
    _reduxOffline?.enable(enable);
}
